import type { ReactNode } from 'react'

export function FeatureGate({
  children,
  enabled,
  fallback = null,
}: {
  children: ReactNode
  enabled: boolean
  fallback?: ReactNode
}) {
  if (!enabled) return fallback
  return children
}
